import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberAchievements } from "./routeType";

const { key, getPath } = getApi("members.achievements.get");

type IExtractedRouteType = IMemberAchievements["achievementSingleRetrieve"];

export type IGetMemberAchievement = IPickSingleQuery<IExtractedRouteType>;

const getMemberAchievement: Fetcher<
  IGetMemberAchievement["response"],
  IGetMemberAchievement["variables"]
> = ({ memberId, achievementId, ...params }) => {
  return axiosClient.get(getPath({ memberId, achievementId }), { params });
};

export const useGetMemberAchievement = createQuery({
  queryKey: [key],
  fetcher: getMemberAchievement,
});
